import { FormFieldConfig } from '@shared/components/search-form/search-form.component';
import { TableColumn } from '@shared/components/data-table/data-table.component';
import { LogicalWarehouse } from './models/logical-warehouse.model';

// ============================================================================
// INTERFACES
// ============================================================================

export type LogicalWarehouseItem = LogicalWarehouse;

// ============================================================================
// TABLE COLUMN CONFIGURATIONS
// ============================================================================

/**
 * Default column property names (shown on first load)
 * Update these constants to change column property names
 */
export const LOGICAL_WAREHOUSE_DEFAULT_COLUMNS = {
  CODE: 'code',
  NAME: 'name',
  TYPE_CODE: 'typeCode',
  CONTACT_NAME: 'contactName',
  CONTACT_PHONE: 'contactPhone',
  DETAIL_ADDRESS: 'detailAddress',
  STATUS: 'status',
} as const;

/**
 * Flexible column property names (can be shown/hidden via column selector)
 * Update these constants to change flexible column property names
 */
export const LOGICAL_WAREHOUSE_FLEXIBLE_COLUMNS = {
  CREATION_DATE: 'creationDate',
} as const;

/**
 * Action column property name
 */
export const LOGICAL_WAREHOUSE_ACTION_COLUMN = {
  ACTIONS: 'actions',
} as const;

/**
 * Default columns order (shown on first load)
 * Update this array to change the default column order
 */
export const LOGICAL_WAREHOUSE_DEFAULT_COLUMNS_ORDER: string[] = [
  LOGICAL_WAREHOUSE_DEFAULT_COLUMNS.CODE,
  LOGICAL_WAREHOUSE_DEFAULT_COLUMNS.NAME,
  LOGICAL_WAREHOUSE_DEFAULT_COLUMNS.TYPE_CODE,
  LOGICAL_WAREHOUSE_DEFAULT_COLUMNS.CONTACT_NAME,
  LOGICAL_WAREHOUSE_DEFAULT_COLUMNS.CONTACT_PHONE,
  LOGICAL_WAREHOUSE_DEFAULT_COLUMNS.DETAIL_ADDRESS,
  LOGICAL_WAREHOUSE_DEFAULT_COLUMNS.STATUS,
];

/**
 * Flexible columns array (can be shown/hidden via column selector)
 * Update this array to change which columns are flexible
 */
export const LOGICAL_WAREHOUSE_FLEXIBLE_COLUMNS_ORDER: string[] = [
  LOGICAL_WAREHOUSE_FLEXIBLE_COLUMNS.CREATION_DATE,
];

export const LOGICAL_WAREHOUSE_COLUMNS: TableColumn[] = [
  {
    label: 'logical_warehouse.table.columns.code',
    prop: LOGICAL_WAREHOUSE_DEFAULT_COLUMNS.CODE,
    width: 120,
  },
  {
    label: 'logical_warehouse.table.columns.name',
    prop: LOGICAL_WAREHOUSE_DEFAULT_COLUMNS.NAME,
    width: 200,
  },
  {
    label: 'logical_warehouse.table.columns.type_code',
    prop: LOGICAL_WAREHOUSE_DEFAULT_COLUMNS.TYPE_CODE,
    type: 'custom',
    width: 100,
  },
  {
    label: 'logical_warehouse.table.columns.contact_name',
    prop: LOGICAL_WAREHOUSE_DEFAULT_COLUMNS.CONTACT_NAME,
    width: 150,
  },
  {
    label: 'logical_warehouse.table.columns.contact_phone',
    prop: LOGICAL_WAREHOUSE_DEFAULT_COLUMNS.CONTACT_PHONE,
    width: 150,
  },
  {
    label: 'logical_warehouse.table.columns.address',
    prop: LOGICAL_WAREHOUSE_DEFAULT_COLUMNS.DETAIL_ADDRESS,
    type: 'custom',
    template: 'addressTemplate',
    width: 280,
  },
  {
    label: 'logical_warehouse.table.columns.status',
    prop: LOGICAL_WAREHOUSE_DEFAULT_COLUMNS.STATUS,
    type: 'status',
    width: 100,
  },
  {
    label: 'logical_warehouse.table.columns.creation_date',
    prop: LOGICAL_WAREHOUSE_FLEXIBLE_COLUMNS.CREATION_DATE,
    width: 135,
    type: 'custom',
    template: 'dateTemplate',
  },
  {
    label: 'logical_warehouse.table.columns.actions',
    prop: LOGICAL_WAREHOUSE_ACTION_COLUMN.ACTIONS,
    type: 'actions',
    width: 200,
  },
];

// ============================================================================
// SEARCH FORM CONFIGURATIONS
// ============================================================================

export const LOGICAL_WAREHOUSE_SEARCH_CONFIG: FormFieldConfig[] = [
  {
    key: 'name',
    label: 'logical_warehouse.search.fields.name',
    type: 'text',
    placeholder: 'logical_warehouse.search.placeholders.enter_name',
  },
  {
    key: 'code',
    label: 'logical_warehouse.search.fields.code',
    type: 'text',
    placeholder: 'logical_warehouse.search.placeholders.enter_code',
  },
  {
    key: 'typeCodes',
    label: 'logical_warehouse.search.fields.type_code',
    type: 'multiselect',
    placeholder: 'logical_warehouse.search.placeholders.select_type_code',
    options: [
      {
        label: 'logical_warehouse.form.type_codes.main',
        value: 'MAIN',
      },
      {
        label: 'logical_warehouse.form.type_codes.store',
        value: 'STORE',
      },
      {
        label: 'logical_warehouse.form.type_codes.cod',
        value: 'COD',
      },
    ],
  },
];
